import { AccountModesEnum } from '@/api';

enum PlanPeriods {
  MONTH = 'month',
  YEAR = 'year',
  UNLIMITED = 'unlimited',
}

const LIMITED_PERIODS: PlanPeriods[] = [PlanPeriods.MONTH, PlanPeriods.YEAR];

const TARIFF_LITE = '';
const TARIFF_PRO = 'pro';
const TARIFF_PRO_PLUS = 'b2b';

enum PlanCategoryEnum {
  LITE = 'lite',
  PRO = 'pro',
  PRO_PLUS = 'proPlus',
}

type TariffType =
  | PlanCategoryEnum.LITE
  | PlanCategoryEnum.PRO
  | PlanCategoryEnum.PRO_PLUS;

const ADDITION_MARK_TO_CATEGORY: Record<string, PlanCategoryEnum> = {
  [TARIFF_LITE]: PlanCategoryEnum.LITE,
  [TARIFF_PRO]: PlanCategoryEnum.PRO,
  [TARIFF_PRO_PLUS]: PlanCategoryEnum.PRO_PLUS,
};

const MODE_PLANS_AVAILABILITY = {
  [AccountModesEnum.LITE]: {
    available: [PlanCategoryEnum.LITE],
    visible: [PlanCategoryEnum.PRO, PlanCategoryEnum.PRO_PLUS],
  },
  [AccountModesEnum.PRO]: {
    available: [PlanCategoryEnum.PRO],
    visible: [PlanCategoryEnum.PRO_PLUS],
  },
  [AccountModesEnum.PRO_PLUS]: {
    available: [PlanCategoryEnum.PRO_PLUS],
    visible: [],
  },
};

type TariffEntity = {
  priority: number;
  title: string;
  slug: PlanCategoryEnum;
  color: string;
  secondaryColor: string;
};

const tariffDisplayData: Record<PlanCategoryEnum, TariffEntity> = {
  [PlanCategoryEnum.LITE]: {
    priority: 1,
    title: 'Lite',
    slug: PlanCategoryEnum.LITE,
    color: '#008D5E',
    secondaryColor: '#D9EEE7',
  },
  [PlanCategoryEnum.PRO]: {
    priority: 2,
    title: 'Pro',
    slug: PlanCategoryEnum.PRO,
    color: '#01359D',
    secondaryColor: '#DAE0EF',
  },
  [PlanCategoryEnum.PRO_PLUS]: {
    priority: 3,
    title: 'Pro+',
    slug: PlanCategoryEnum.PRO_PLUS,
    color: '#141822',
    secondaryColor: '#F1F3F6',
  },
};

export {
  PlanPeriods,
  LIMITED_PERIODS,
  TARIFF_LITE,
  TARIFF_PRO,
  TARIFF_PRO_PLUS,
  PlanCategoryEnum,
  ADDITION_MARK_TO_CATEGORY,
  MODE_PLANS_AVAILABILITY,
  tariffDisplayData,
};

export type { TariffType };
